// extracted by mini-css-extract-plugin
module.exports = {"reset-button":"SimulationTypeToggle_reset-button__Ma4Bh","button-card":"SimulationTypeToggle_button-card__QHYfy"};